export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    title: that.$l('table_label_displaySalesAvatar') || '头像',
    field: 'displayAvatar',
    align: 'center',
    minWidth: 70,
    slots: { default: 'displayAvatar' },
  },
  {
    title: that.$l('table_label_displaySalesName') || '姓名',
    field: 'displayName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 160,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_bizTeamRoles') || '业务角色',
    field: 'v_bizTeamRoles',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
  },
  {
    title: that.$l('table_label_displaySalesCategoryName') || '负责客户品类',
    field: 'displayCategoryName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    formatter: ({ row }) => {
      const { custCategoryNameList } = row
      if (!custCategoryNameList?.length) return ''
      return custCategoryNameList.join('、')
    },
  },
  {
    title: that.$l('table_label_userResponsibilities') || '业务职责说明',
    field: 'userResponsibilities',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
  },
  {
    title: that.$l('table_label_displaySalesContacts') || '联系电话',
    field: 'displayContacts',
    headerAlign: 'center',
    align: 'left',
    minWidth: 220,
    slots: { default: 'displayContacts' },
  },
  {
    title: that.$l('table_label_displaySalesDep') || '所属部门',
    field: 'displayDep',
    headerAlign: 'center',
    align: 'left',
    minWidth: 260,
    formatter: ({ row }) => {
      const { orgName, depFullName } = row
      return [orgName, depFullName].filter(Boolean).join('/')
    },
  },
  {
    title: that.$l('table_title_modifyInfo') || '数据更新',
    field: 'modifyInfo',
    minWidth: 170,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'modifyInfo' },
  },
]
